import { useI18n } from "@/i18n";
import { formatDatesDuration } from "@/utils";
import moment from "moment";
import { Ref, ref } from "vue";

const DEFAULT_DATE_FORMAT_OPTIONS = ["MMMM YYYY", "MMM YYYY", "YYYY-MM", "YYYY"] as const;

export function useDateFormatter(dateFormat: Ref<string>) {
  const { t, locale } = useI18n();
  const dateFormatOptions = ref<string[]>([...DEFAULT_DATE_FORMAT_OPTIONS]);

  const formatProjectDate = (start: any, end: any, shortMonth: boolean = false) => {
    const chosen =
      dateFormat.value || (shortMonth ? dateFormatOptions.value[1] : dateFormatOptions.value[0]);

    if (chosen?.startsWith("duration")) {
      const dayDiff = moment(end).diff(moment(start), "days");
      if (chosen === "duration-years") {
        const years = Math.round(dayDiff / 365);
        return `${years} year${years === 1 ? "" : "s"}`;
      } else if (chosen === "duration-months") {
        const months = Math.round(dayDiff / (365 / 12));
        return `${months} month${months === 1 ? "" : "s"}`;
      } else if (chosen === "duration-weeks") {
        const weeks = Math.round(dayDiff / (365 / 52));
        return `${weeks} week${weeks === 1 ? "" : "s"}`;
      }
    }

    const ongoingProject = !moment(end).isValid() || moment(end).diff(moment()) > 0;
    return `${moment(start).format(chosen)} - ${
      ongoingProject ? t("CV.ongoing") : moment(end).format(chosen)
    }`;
  };

  const formatDate = (date: any): string => {
    return moment(date || undefined)
      .locale(locale.value)
      .format(dateFormat.value || dateFormatOptions.value[0]);
  };

  const formatProjectDuration = (start: string, end: string) => {
    return formatDatesDuration(
      moment(start).startOf("month").format("YYYY-MM-DD"),
      moment(end).endOf("month").format("YYYY-MM-DD"),
      { months: 1 },
      true,
      locale.value
    );
  };

  return {
    dateFormatOptions,
    formatProjectDate,
    formatDate,
    formatProjectDuration,
  };
}
